import { useEffect } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { CSPProvider } from '@base-ui/react/csp-provider';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { TetrisThemeProvider, StyleReset, useIsMobile } from '@pocketlaw/tetris';
import { BrowserRouter } from 'react-router-dom';
import apollo from 'app/domains/apollo';
import AuthProvider from 'app/domains/auth/hooks/useAuth';
import { UniversalSearchProvider } from 'app/domains/global-search';
import { isMobileVar } from 'shared/domains/apollo/utils/cacheVars';
import { localTheme } from 'shared/domains/common-ui/localTheme';
import { ErrorBoundary } from 'shared/domains/errors';
import { GtmProvider } from 'shared/domains/tracking';
import { Routes } from './screens';
export function Root(props) {
    const { auth, language, children } = props;
    const { getTetrisTheme } = localTheme;
    const isMobile = useIsMobile();
    useEffect(() => {
        isMobileVar(isMobile);
    }, [isMobile]);
    useEffect(() => {
        if (document.documentElement.lang !== language) {
            document.documentElement.lang = language;
        }
    }, [language]);
    // @ts-expect-error: __webpack_nonce__ is not defined on window
    // eslint-disable-next-line no-underscore-dangle
    const nonce = window.__webpack_nonce__ || '';
    return (<CSPProvider nonce={nonce} disableStyleElements>
      <TetrisThemeProvider theme={getTetrisTheme()}>
        <StyleReset />
        <I18nProvider i18n={i18n}>
          <ErrorBoundary>
            <ApolloProvider client={apollo}>
              <BrowserRouter>
                <AuthProvider client={auth} locale={language}>
                  <GtmProvider>
                    <UniversalSearchProvider>{children || <Routes />}</UniversalSearchProvider>
                  </GtmProvider>
                </AuthProvider>
              </BrowserRouter>
            </ApolloProvider>
          </ErrorBoundary>
        </I18nProvider>
      </TetrisThemeProvider>
    </CSPProvider>);
}
